import { Component } from 'react';
import ReactDOM from 'react-dom';

export default class NotificationPortal extends Component {
    constructor() {
        super();
        this.el = document.createElement('span');
        this.notificationPortalRoot = document.getElementById(
            'notification-portal'
        );
    }

    componentDidMount() {
        if (this.notificationPortalRoot) {
            this.notificationPortalRoot.appendChild(this.el);
        }
    }

    componentWillUnmount() {
        if (this.notificationPortalRoot) {
            this.notificationPortalRoot.removeChild(this.el);
        }
    }

    render() {
        const { children } = this.props;
        return ReactDOM.createPortal(children, this.el);
    }
}



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/portals/notification-portal.jsx